<template>
  <div class="serve-info">
    <loading :isShow="pageLoading" />
    <!-- <div class="tools-box">
      <Tooltip transfer content="如果发现服务费异常或缺失，您可以根据异常原因修复后点击重新生成" placement="bottom-start">
        <Button type="primary" :loading="btnLoading" @click="generateCommission">重新生成费用</Button>
      </Tooltip>
    </div> -->
    <template v-if="!pageLoading && list.length == 0">
      <span v-if="noCommissionReason" class="error-box">{{ noCommissionReason }}</span>
      <noData v-else class="null-box"></noData>
    </template>
    <!-- 费率表 -->
    <commissionInfoTable v-else-if="!pageLoading" class="page-use" :list="list"></commissionInfoTable>
    <!-- 确认弹窗 -->
    <confirm-Modal ref="confirmModal"></confirm-Modal>
  </div>
</template>

<script>
import confirmModal from '@/components/commons/confirmModal';
import commissionInfoTable from './commissionInfoTable';
export default {
  components: { 
    confirmModal,
    commissionInfoTable 
  },
  data() {
    return {
      pageLoading: false,
      btnLoading: false,
      list: [],
      noCommissionReason: '', // 无费用原因
    };
  },
  computed: {
  },
  watch: {},
  created() {
    this.getDetail()
  },
  methods: {
    getDetail() {
      this.pageLoading = true;
      this.$http({
        url: '/buz/grouppolicy/commission',
        type: 'GET',
        data: {
          policyNo: this.$route.query.policyNo
        }
      }).then(res => {
        this.list = res.data.commissionInfoVoList;
        this.noCommissionReason = res.data.noCommissionReason;
      }).finally(()=>{
        this.pageLoading = false;
      })
    },
    // 生成费用
    generateCommission() {
      if(!this.$units.pointAction('order_50_20')) {
        this.$notice.error('无权操作，请联系您的上级');
        return
      }
      this.generateCommissionAjax(1).then(() => {
        this.$refs.confirmModal
          .open({
            title: '提示',
            content: '请确认是否重新生成费用？相关未对账或未结算数据会同步更新'
          })
          .then(() => {
            this.generateCommissionAjax(0).then(() => {
              this.$notice.success('生成费用成功');
            });
          });
      });
    },
    // 生成费用请求 isOnlyCheck 是否仅验证
    generateCommissionAjax(isOnlyCheck) {
      this.btnLoading = true;
      return this.$http({
        url: `/buz/grouppolicy/policyAgain`,
        type: 'GET',
        data: {
          policyNo: this.$route.query.policyNo,
          isOnlyCheck: isOnlyCheck
        }
      }).finally(() => {
        this.btnLoading = false;
        if(!isOnlyCheck) {
          this.getDetail();
        }
      });
    }
  }
};
</script>
<style lang="scss" scoped>
.serve-info  {
  min-height: 200px;
}
.error-box {
  color: red;
  text-align: center;
  padding-top: 30px;
  width: 100%;
  display: block;
}
</style>